"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Roundel = Roundel;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledRoundel = require("./styled-roundel");
var _excluded = ["className", "dataTestId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var propTypes = {
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['s', 'm', 'l', 'xl', 'responsive']),
  variant: _propTypes["default"].oneOf(['red', 'black', 'white'])
};
var defaultProps = {
  className: undefined,
  dataTestId: undefined,
  size: 'responsive',
  variant: 'white'
};
function Roundel(_ref) {
  var className = _ref.className,
    dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledRoundel.StyledRoundel, _extends({
    className: className,
    "data-testid": dataTestId || 'fuse-roundel-data-test-id'
  }, props));
}
Roundel.propTypes = propTypes;
Roundel.defaultProps = defaultProps;
var _default = exports["default"] = Roundel;